/*
    ____,-------------------------------,____
    \   |             Public            |   /
    /___|-------------------------------|___\

    В Safari бывают проблемы с доступом к localStorage и даже sessionStorage.
    Особенно в режиме инкогнито или при блокировке кук
*/

export function getLocalStorage(): Storage {
  if (!local) {
    local = createStorage(() => localStorage);
  }

  return local;
}

export function getSessionStorage(): Storage {
  if (!session) {
    session = createStorage(() => sessionStorage);
  }

  return session;
}

/*
    ____,-------------------------------,____
    \   |            Factory            |   /
    /___|-------------------------------|___\
*/

let local: Storage | null = null;
let session: Storage | null = null;

function createStorage(getStorage: () => Storage): Storage {
  let storage: Storage | null = null;

  try {
    const key = 'c4f6f5288a1e483ea35feb2566ef3f15';
    storage = getStorage();
    storage.setItem(key, key);
    storage.removeItem(key);
    return storage;
  } catch {
    return new MemoryStorage();
  }
}

/*
    ____,-------------------------------,____
    \   |           Fallback            |   /
    /___|-------------------------------|___\
*/

class MemoryStorage implements Storage {
  private data: { [key: string]: string } = {};

  clear(): void {
    this.data = {};
  }

  getItem(name: string): string | null {
    if (Object.prototype.hasOwnProperty.call(this.data, name)) {
      return this.data[name]!;
    }
    return null;
  }

  key(index: number): string | null {
    return Object.keys(this.data)[index] || null;
  }

  removeItem(name: string): void {
    delete this.data[name];
  }

  setItem(name: string, value: string): void {
    this.data[name] = value;
  }

  get length(): number {
    return Object.keys(this.data).length;
  }
}
